import React from 'react';
import {to3SeparatedComma} from "../../util/DominantUtil";

const fieldNames = {
    c: 'آخرین',
    cl: 'پایانی',
    o: 'دیروز',
    v: 'حجم معاملات',
    l: 'کمترین',
    h: 'بیشترین',
    vl: 'ارزش معاملات',
    w: 'میانگین قیمت',
    n: 'تعداد معاملات',
};

const KeyValueList = ({ data }) => {
    const keys = Object.keys(fieldNames);
    const renderedItems = keys
        .filter((key) => data[key] !== undefined && data[key] > 0)
        .map((key, index) => (
            <div key={key} className={`w-full sm:w-1/2 ${index % 2 === 0 ? 'sm:pr-3' : ''}`}>
                <div className="flex justify-between" aria-label={`${fieldNames[key]}: ${data[key]}`}>
                    <div className="font-semibold mr-2">
                        <strong>{fieldNames[key]}</strong>
                    </div>
                    <div>{to3SeparatedComma(data[key])}</div>
                </div>
            </div>
        ));

    const rows = [];
    for (let i = 0; i < renderedItems.length; i += 2) {
        rows.push(
            <div key={i} className="flex flex-wrap">
                {renderedItems[i]}
                {renderedItems[i + 1] || <div className="w-1/2"></div>}
            </div>
        );
    }

    return <div className='my-2'>{rows}</div>;
};

export default KeyValueList;
